import React from 'react';
import PropTypes from 'prop-types';

import modalHeaderUseStyles from './modalHeaderUseStyles';

const ModalHeader = ({ addOn, header, id, subHeader, stretched }) => {
  if (subHeader && addOn) {
    throw new Error('You cannot have both subHeader and addon');
  } else if (!header && subHeader) {
    throw new Error('You must provide a header if you provide a subHeader');
  }

  const {
    wdsModalAddOn,
    wdsModalHeader,
    wdsModalSubText,
    wdsModalText,
    wdsModalTitle,
  } = modalHeaderUseStyles({
    addOn,
    stretched, // @todo: this doesn't look like its used anymore
  });

  return (
    <section className={wdsModalHeader}>
      <div className={wdsModalTitle}>
        <If condition={header}>
          <h2 className={wdsModalText} id={id}>
            {header}
          </h2>
        </If>
        <If condition={subHeader}>
          <p className={wdsModalSubText}>{subHeader}</p>
        </If>
      </div>
      <If condition={addOn}>
        <div className={`${wdsModalAddOn}`}>{addOn}</div>
      </If>
    </section>
  );
};

ModalHeader.propTypes = {
  /**
   * Addon Modal Header, can be icon, button, text
   */
  addOn: PropTypes.node,
  /**
   * Define header content
   */
  header: PropTypes.node,
  /**
   * Unique identifiter for Modal Header
   */
  id: PropTypes.string,
  /**
   * If true, header content will fit entire width of parent container
   */
  stretched: PropTypes.bool,
  /**
   * Define subheader content
   */
  subHeader: PropTypes.node,
};

ModalHeader.defaultProps = {
  addOn: undefined,
  header: undefined,
  id: undefined,
  stretched: false,
  subHeader: undefined,
};

export default ModalHeader;
